import { Box, type BoxProps } from "@chakra-ui/react";
import React from "react";
import { VideoModal } from "ui/video";

const videoShort = "https://cdn.sanity.io/files/pwmfmi47/production/90199539c7ff4d44469b0ad82fbb2829e1c96db1.mp4";
const videoSrc = "https://cdn.sanity.io/files/pwmfmi47/production/4f29aacba1ef81481c93dd168398946c99db8c92.mp4";
const videoCaptions = "/assets/platform/ai-decisioning/aid-demo-captions.vtt";
const videoThumbnail =
  "https://cdn.sanity.io/images/pwmfmi47/production/01f47f423499361da59932fc739e46f02ce30cd9-3010x1686.webp";

export function AidDemoVideo(props: BoxProps) {
  return (
    <Box
      border="1px"
      borderColor="brand.border.extraLight"
      borderRadius={{ base: "small", md: "big" }}
      mt={{ base: "bigger", md: "biggest" }}
      maxW="5xl"
      mx="auto"
      overflow="hidden"
      {...props}
    >
      <VideoModal
        iconTheme="dark"
        shortSrc={videoShort}
        src={videoSrc}
        captions={videoCaptions}
        thumbnail={videoThumbnail}
        uploadDate="Feb 10, 2025"
        videoId="aid-demo"
        title="AI Decisioning Demo"
        description="Alec Haase gives a quick overview and walk through of AI Decisioning, an AI platform that delivers unique and optimized experiences for each customer — without manual work or rigid rule-based logic."
      />
    </Box>
  );
}
